<template>
    <div>
        <el-dialog title="" :visible.sync="visible" center width="600px"
                   :before-close="closeDialog"
                   append-to-body>

            <div class="page-address add-address">
                <div class="container">
                    <div class="oval"></div>
                    <div class="page-title" v-text="title"></div>

                    <div class="form">
                        <div class="form-box clearfix">
                            <el-form label-position="top" label-width="80px" :model="form" :rules="rules" ref="form">

                                <div class="add-box">
                                    <el-form-item label="姓名" prop="userName" :error="userNameErrorMsg">
                                        <el-input v-model="form.userName" type="text" maxlength="50"
                                                  clearable></el-input>
                                    </el-form-item>

                                    <el-form-item label="收货人手机号" prop="phone" :error="phoneErrorMsg">
                                        <el-input v-model="form.phone" type="tel" maxlength="11" clearable></el-input>
                                    </el-form-item>
                                </div>
                                <div class="add-box">
                                    <el-form-item label="省份" prop="provinceId" :error="provinceErrorMsg">
                                        <el-select v-model="form.provinceId" placeholder="请选择省份"
                                                   @change="changeProvince">
                                            <el-option v-for="item in provinceList"
                                                       :key="item.id" :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="城市" prop="cityId" :error="cityErrorMsg">
                                        <el-select v-model="form.cityId" placeholder="请选择城市" @change="changeCity">
                                            <el-option v-for="item in cityList"
                                                       :key="item.id" :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="区" prop="areaId" :error="areaErrorMsg">
                                        <el-select v-model="form.areaId" placeholder="请选择区">
                                            <el-option v-for="item in areaList"
                                                       :key="item.id" :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>

                                <div class="add-box-detail">
                                    <el-form-item label="详细地址" prop="detail" :error="detailErrorMsg">
                                        <el-input v-model="form.detail" type="text" maxlength="200"
                                                  clearable></el-input>
                                    </el-form-item>
                                </div>

                                <el-form-item>
                                    <el-checkbox v-model="isDefault">设定为默认地址</el-checkbox>
                                </el-form-item>

                                <el-form-item>
                                    <app-button @click.native="submitForm" size="md" color="golden-solid">保存
                                    </app-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import validate from '../../util/validate';

    export default {
        data() {
            return {
                id: '',
                provinceList: [],
                cityList: [],
                areaList: [],

                form: {
                    userName: '',
                    phone: '',
                    provinceId: '',
                    cityId: '',
                    areaId: '',
                    detail: '',
                },

                userNameErrorMsg: '',
                phoneErrorMsg: '',
                provinceErrorMsg: '',
                cityErrorMsg: '',
                areaErrorMsg: '',
                detailErrorMsg: '',

                rules: {
                    userName: [{required: true, message: '请输入姓名', trigger: 'blur'},],
                    phone: [
                        {required: true, message: '请输入收货人联络电话', trigger: 'blur'},
                        {validator: validate.phone, trigger: 'blur'}
                    ],
                    provinceId: [{required: true, message: '请选择省份', trigger: 'change'},],
                    cityId: [{required: true, message: '请选择城市', trigger: 'change'},],
                    areaId: [{required: true, message: '请选择区', trigger: 'change'},],
                    detail: [{required: true, message: '请输入详细地址', trigger: 'blur'},],
                },

                isDefault: false,
            };
        },
        props: ['visible', 'selectId'],
        components: {},
        computed: {
            title: function () {
                return this.selectId ? '编辑收货地址' : '新增收货地址';
            },
        },
        watch: {
            selectId: {
                handler(curVal, oldVal) {
                    if (curVal != oldVal) {
                        this.resetForm();

                        if (curVal)
                            this.getAddressItem();
                    }

                }, deep: true, immediate: true
            },
        },
        created() {
            this.getProvince();
        },
        activated() {
        },
        mounted() {
        },
        methods: {
            getAddressItem() {
                var _selectId = this.selectId;
                this.$api.getAddressItem(_selectId).then((res) => {

                    this.form = {
                        userName: res.userName,
                        phone: res.phone,
                        provinceId: res.provinceId.toString(),
                        cityId: res.cityId.toString(),
                        areaId: res.areaId.toString(),
                        detail: res.detail,
                    };
                    this.id = res.id;
                    this.isDefault = res.isDefault == 1 ? true : false;

                    // this.getProvince();
                    this.getCity();
                    this.getArea();
                });
            },
            getProvince() {
                this.$api.getAddressSelect().then((res) => {
                    this.provinceList = res.list;
                });
            },
            changeProvince() {
                this.cityList = [];
                this.areaList = [];
                this.form.cityId = '';
                this.form.areaId = '';
                this.getCity();
            },
            getCity() {
                var inData = {id: this.form.provinceId};
                this.$api.getAddressSelect(inData).then((res) => {
                    this.cityList = res.list;
                });
            },
            changeCity() {
                this.areaList = [];
                this.form.areaId = '';
                this.getArea();
            },
            getArea() {
                var inData = {id: this.form.cityId};
                this.$api.getAddressSelect(inData).then((res) => {
                    this.areaList = res.list;
                });
            },
            submitForm() {
                var self = this;
                var _form = this.form;
                var _selectId = this.selectId;

                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        _form.isDefault = this.isDefault ? 1 : 0;
                        _form.addrId = _selectId ? _selectId : '';

                        this.$store.dispatch('address/editAddress', _form);

                        this.resetForm();
                        this.$emit('closeDialog');

                    } else {
                        return false;
                    }
                });
            },
            resetForm() {
                //clear data
                this.isDefault = false;
                // this.provinceList = [];
                this.cityList = [];
                this.areaList = [];

                this.form = {
                    userName: '',
                    phone: '',
                    provinceId: '',
                    cityId: '',
                    areaId: '',
                    detail: '',
                };

                this.userNameErrorMsg = '';
                this.phoneErrorMsg = '';
                this.provinceErrorMsg = '';
                this.cityErrorMsg = '';
                this.areaErrorMsg = '';
                this.detailErrorMsg = '';
            },
            closeDialog() {
                this.$emit("closeDialog");
            },
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    @import "../../style/page-common";

    .page-address {
        width: 550px;
        padding: 0 25px;
        margin: 0 auto;

        .container {
            position: relative;
        }

        .el-select {
            width: 100%;
        }

        .form {
            padding-bottom: 0px;
        }

        .add-box {
            display: flex;
            justify-content: flex-start;
        }
    }
</style>

<style lang="scss" type="text/scss">
    @import "../../style/common/form";

    .add-box {
        .el-form-item {
            width: 240px !important;
            margin-right: 20px;
        }
    }

    .add-box-detail {
        .el-form-item {
            width: 480px !important;
            margin-right: 20px;
        }
    }
</style>